module.exports = __webpack_public_path__ + "37ba336af354630fadf79b75006fc313.svg";